import React from 'react'

const Spinner = () => {
  return (
    <div className='custom-loader'>
      
    </div>
  )
}

export default Spinner
